import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, take } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatRipple } from '@angular/material/core';

import { RaceFacadeService } from '@app/facade-services/race/race-facade.service';
import { Race } from '@app/rest-client/faxe/models/race';
import { LoginService } from '@app/services/login.service';
import { SelectedRaceService } from '@app/services/selected-race.service';
import { SnackService } from '@app/components/shared/snack/snack.service';
import { MenuService } from '@app/components/shared/page-layout/menu.service';
import { defined, formatDateSvSE } from '@app/fremework/functions';
import { Router } from '@angular/router';
import { PageId } from '@app/constants/page-id';

@Component({
  selector: 'faxe-select-race',
  imports: [MatListModule, MatIconModule, MatRipple],
  templateUrl: './select-race.component.html',
  styleUrl: './select-race.component.scss',
})
export class SelectRaceComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  races: Race[];

  constructor(
    private readonly raceFacadeService: RaceFacadeService,
    private readonly loginService: LoginService,
    private readonly snackService: SnackService,
    private readonly menuService: MenuService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    const twoWeeksAgo = new Date();
    twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 14);

    this.raceFacadeService
      .fetchRace('SelectRaceComponent')
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((races) => {
        this.races =
          races
            ?.filter(
              (r) => !defined(r.raceEnd) || new Date(r.raceEnd) >= twoWeeksAgo
            )
            .sort(
              (a, b) =>
                new Date(b.raceBegin).getDate() -
                new Date(a.raceBegin).getDate()
            ) || [];
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onRaceSelected(race: Race) {
    this.loginService
      .checkLogin(race.raceGuid)
      .pipe(take(1))
      .subscribe((userToken) => {
        if (userToken) {
          this.snackService.showSnackBar(`Välkommen ${userToken?.signature}`);
          this.menuService.openOnce();
          void this.router.navigate([`/${PageId.adminHome}`])
            .catch(() => this.snackService.showSnackBar('Kunde inte öppna Load test sidan'));
        }
      });
  }

  protected readonly formatDateSvSE = formatDateSvSE;
}
